import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'headerName' })
export class HeaderNamePipe implements PipeTransform {
  transform(value: Array<any>, ...args: any[]): string {
    let timezone;
    if (args[3]) {
      timezone = moment.tz.zone(args[3]).abbr(moment().valueOf());
    }
    let name = args[0] + ' | ' + args[1] + ' | ' + args[2] + ' | (' + timezone + ')';

    return name;
  }
}
